import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import Brand from 'helpers/brand'

import Apptentive from 'helpers/apptentive'
import Environment from 'helpers/environment'

import useChatbotTermsApi from 'hooks/useChatbotTermsApi'

import { color } from 'styles/colors'

const Footer = () => {
  const { chatbotTermsUpToDate } = useChatbotTermsApi()

  let warrantylookupUrl
  if (Brand.isASAirHome()) {
    warrantylookupUrl = 'https://warrantylookup.tranetechnologies.com/wrApp/index.html#/americanStandard/search'
  } else {
    warrantylookupUrl = 'https://warrantylookup.tranetechnologies.com/wrApp/index.html#/trane/search'
  }

  return (
    <S.Footer>
      <S.Copyright>©{new Date().getFullYear()} {Brand.brandName()}</S.Copyright>

      <span>|</span>

      <S.InternalLink to="/legal">
        Legal
      </S.InternalLink>

      <span>|</span>

      <S.InternalLink to="/terms_and_conditions">
        Terms and Conditions
      </S.InternalLink>

      <span>|</span>

      {chatbotTermsUpToDate && (
        <>
          <S.InternalLink to="/ai_chatbot?showTerms=true">
            AI Terms of Use
          </S.InternalLink>

          <span>|</span>
        </>
      )}

      <S.ExternalLink target="_blank" rel="noreferrer" href="https://www.tranetechnologies.com/en/index/privacy-policy.html">
        Privacy Policy
      </S.ExternalLink>

      <span>|</span>

      <S.ExternalLink target="_blank" rel="noreferrer" href={warrantylookupUrl}>
        Warranty Lookup
      </S.ExternalLink>

      <span>|</span>

      <S.ExternalLink onClick={
        () => Apptentive.sendEvent(
          Environment.isProduction()
            ? Brand.prodApptentiveFeedbackForm()
            : Brand.devApptentiveFeedbackForm()
        )
      }
      >
        Feedback
      </S.ExternalLink>
    </S.Footer>
  )
}

export default Footer

const linkStyle = `
  margin: 0 10px;
  color: ${color('footerText')};
  
  &:hover {
    color: ${color('footerText')};
    text-decoration: underline;
  }
`

const S = {
  Footer: styled.div`
    padding: 10px 10px 10px 20px;
    font-weight: bold;
    color: ${color('footerText')};
    background: ${color('chatbotBackground')};
  `,
  Copyright: styled.span`
    margin-right: 10px;
  `,
  ExternalLink: styled.a`
    ${linkStyle}
  `,
  InternalLink: styled(NavLink)`
    ${linkStyle}
  `
}
